import React, { useCallback, useState } from 'react';
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  setDoc,
} from 'firebase/firestore';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { v4 } from 'uuid';
import { useSettings } from '~/hooks/settings';
import { useAppAuth } from '~/hooks/appAuth';
import { DB } from '~/services/firebase';
import getValidationErrors from '~/utils/getValidationErrors';
import IClient from '~/interfaces/IClient';

interface AddProductProps {
  onClose(): void;
}

interface FormData {
  name: string;
  phone: string;
}

const Login: React.FC<AddProductProps> = ({ onClose }) => {
  const { updateUser } = useAppAuth();

  const { company } = useSettings();
  const [isRegister, setIsRegister] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [data, setData] = useState<FormData>({} as FormData);
  const [errors, setErrors] = useState<any>({});

  const handleSubmit = useCallback(
    async event => {
      event.preventDefault();
      setErrors({});

      try {
        const validateData = {
          name: data.name,
          phone: '',
        };

        const cleaned = `${data.phone}`.replace(/\D/g, '');
        const match = cleaned.match(/^(\d{2})(\d{5})(\d{4})$/);

        if (match) {
          validateData.phone = `(${match[1]}) ${match[2]}-${match[3]}`;
        }

        const schema = Yup.object().shape({
          name: isRegister
            ? Yup.string().required('O nome é obrigatório')
            : Yup.string(),
          phone: Yup.string().required('Informe um número de celular válido'),
        });

        await schema.validate(validateData, {
          abortEarly: false,
        });

        // setLoading(true);

        const { name, phone } = validateData;

        // let parseCompanyPhone = phone.replace('(', '');
        // parseCompanyPhone = parseCompanyPhone.replace(')', '');
        // parseCompanyPhone = parseCompanyPhone.replace('-', '');
        // parseCompanyPhone = parseCompanyPhone.replace(' ', '');
        // parseCompanyPhone = parseCompanyPhone.trim();

        const uid = v4();

        const parseData: any = {
          uid,
          name,
          whatsapp: phone,
          user_id: company.user_id,
          company_id: company.uid,
          status: true,
        };

        // verificar se o usuario ja esta cadastrado para o restaurante
        let client = {} as IClient;

        const q = query(
          collection(DB, 'clients'),
          where('whatsapp', '==', phone),
          where('company_id', '==', company.uid),
        );
        const querySnapshot = await getDocs(q);

        if (querySnapshot.docs.length > 0) {
          const {
            uid: dataId,
            name: dataName,
            whatsapp,
            orderAddress,
          } = querySnapshot.docs[0].data() as IClient;

          client = {
            uid: dataId,
            name: dataName,
            whatsapp,
            orderAddress,
          } as IClient;
        }

        // cadastro
        if (isRegister && !client.uid) {
          await setDoc(doc(DB, 'clients', uid), parseData);
          updateUser(parseData);
          onClose();
          // setLoading(false);
          return;
        }

        // considerar como login
        if ((isRegister && client.uid) || (!isRegister && client.uid)) {
          updateUser(client);
          onClose();
          // setLoading(false);
          return;
        }

        // cliente nao encontrado
        if (!isRegister && !client.uid) {
          // informar um erro
          alert('Você não possui uma conta, por favor realize o cadastro.');
          setIsRegister(true);
          // setLoading(false);
          return;
        }
      } catch (err: any) {
        console.log(err);
        // setLoading(false);
        if (err instanceof Yup.ValidationError) {
          const parseErrors = getValidationErrors(err);
          setErrors(parseErrors);
        }
      }
    },
    [company, data, isRegister, onClose, updateUser],
  );

  return (
    <>
      <div
        className="modal fade show"
        id="addproductcart"
        tabIndex={-1}
        aria-hidden="true"
        style={{ display: 'block' }}
      >
        <div className="modal-dialog modal-sm modal-dialog-centered">
          <div className="modal-content product border-0 shadow-sm">
            <div className="modal-body">
              <h6
                className="text-color-theme mb-3 text-center"
                style={{ color: company.app_color, textTransform: 'uppercase' }}
              >
                Acesse sua conta
              </h6>

              <form className="signup" onSubmit={e => e.preventDefault()}>
                <label className="form-label">Informe seu celular</label>
                <div className="input-group">
                  <span className="input-group-text" id="basic-addon1">
                    <i className="bi bi-telephone" />
                  </span>
                  <input
                    type="text"
                    className="form-control phone"
                    maxLength={15}
                    onChange={ev => {
                      setData({
                        ...data,
                        phone: ev.target.value,
                      });
                    }}
                  />
                </div>
                {errors.phone && (
                  <label className="invalid">{errors.phone}</label>
                )}

                {isRegister && (
                  <>
                    <label className="form-label mt-3">Informe seu nome</label>
                    <div className="input-group">
                      <span className="input-group-text" id="basic-addon1">
                        <i className="bi bi-person" />
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        onChange={ev => {
                          setData({
                            ...data,
                            name: ev.target.value,
                          });
                        }}
                      />
                    </div>
                    {errors.name && (
                      <label className="invalid">{errors.name}</label>
                    )}
                  </>
                )}

                <div className="d-flex justify-content-center mt-2">
                  {!isRegister && (
                    <button
                      type="button"
                      className="btn btn-link text-color-theme"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        setIsRegister(true);
                      }}
                      style={{
                        color: company.app_color,
                        textTransform: 'unset',
                        fontSize: 14,
                      }}
                    >
                      Não possui uma conta?
                      <br />
{' '}
Cadastre-se!
</button>
                  )}

                  {isRegister && (
                    <button
                      type="button"
                      className="btn btn-link text-color-theme"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        setIsRegister(false);
                      }}
                      style={{
                        color: company.app_color,
                        textTransform: 'unset',
                        fontSize: 14,
                      }}
                    >
                      Já possui uma conta?
                      <br />
{' '}
Entrar!
</button>
                  )}
                </div>
              </form>
            </div>

            <div className="modal-footer justify-content-center">
              {!isRegister && (
                <button
                  type="button"
                  className="btn btn-link text-color-theme"
                  data-bs-dismiss="modal"
                  onClick={handleSubmit}
                  style={{ color: company.app_color }}
                >
                  Entrar
                </button>
              )}

              {isRegister && (
                <button
                  type="button"
                  className="btn btn-link text-color-theme"
                  data-bs-dismiss="modal"
                  onClick={handleSubmit}
                  style={{ color: company.app_color }}
                >
                  Cadastrar
                </button>
              )}
            </div>
          </div>
        </div>
        <div
          className="modal-backdrop fade show"
          style={{ background: '#00000060' }}
          onClick={onClose}
        />
      </div>
      <Helmet>
        <script src={`${process.env.PUBLIC_URL}/assets/js/masks.js`} />
      </Helmet>
    </>
  );
};

export default Login;
